import { TypographyStylesProvider } from '@mantine/core';

type DangerouslySetInnerHTMLProps = {
  __html: string;
};

export const DangerouslySetInnerHTML = ({
  __html,
}: DangerouslySetInnerHTMLProps) => {
  return (
    <TypographyStylesProvider>
      <div dangerouslySetInnerHTML={{ __html }} />
    </TypographyStylesProvider>
  );
};
